module.exports = __webpack_public_path__ + "img/guileme.69165599.png";